import React from 'react';
export var CheckboxInput = function (_a) {
    var name = _a.name, title = _a.title, value = _a.value, handleChange = _a.handleChange, checked = _a.checked;
    //console.log(props.value);
    return (React.createElement("div", { className: "pretty p-default form-group" },
        React.createElement("input", { onChange: handleChange, value: value, className: "a-form-control a-form-control--checkbox", type: "checkbox", name: name, id: "".concat(value, "_id"), checked: checked }),
        React.createElement("div", { className: "state" },
            React.createElement("label", { htmlFor: "".concat(value, "_id") }, title))));
};
//# sourceMappingURL=CheckboxInput.js.map